import type { PipeJobRef } from './jobNumbersFromSetup';
import { jobRefsKey } from './jobNumbersFromSetup';

/**
 * Session key for drill-down caches. Includes applied pipes + jobs so a new
 * Apply invalidates NDT / WPS prefetch (unlike the old project|pipeId key).
 */
export function buildDrillDownSessionKey(
  projectId: number | null | undefined,
  pipeIds: readonly (string | number)[] | null | undefined,
  jobRefs: readonly PipeJobRef[] | null | undefined,
): string | null {
  if (projectId == null) return null;
  const pipes = [...(pipeIds ?? [])]
    .map((id) => String(id).trim())
    .filter(Boolean)
    .sort()
    .join(',');
  const jobs = jobRefsKey(jobRefs ?? []);
  return `${projectId}|${pipes}|${jobs}`;
}
